import React, { Component } from 'react';
import Header from '../Common/Component/Header';
import Sidebar from '../Common/Component/Sidebar';
import { TimePicker, Select, Modal, Drawer } from 'antd';
var {Option} = Select;
class WeekSetupViewAllocation extends Component {
  render() {
    return (
      <div id="wrapper">
        <div className="content-area">
          {/* Header */}
          <Header />

          {/* Sidebar */}
          <Sidebar history={this.props.history} />
          <div className="container">
            <div className="aside-area pt-0 account_module_wrapper">
              <aside className="laside fo-side d-flex flex-column justify-content-between">
                <div className="w-100">
                  <h3>Field Ops</h3>
                  <div className="form-group mb-10">
                    <TimePicker
                      className="swhite" />
                  </div>

                  <div className="gray_box teal_box">
                    <div className="card-body">
                      <div className="fitem-check check-header">
                        <input type="checkbox" className="fitem-ck-input" id="RC_main" name="checkboxs" checked/>
                        <label htmlFor="RC_main" className="fitem-ck-txt">Residential Cleaning</label>
                      </div>
                      <div className="check-body">
                        <div className="d-flex justify-content-between ai-center mb-5">
                          <div className="fitem-check">
                            <input type="checkbox" className="fitem-ck-input" id="RC_sub_1" name="checkboxs" checked/>
                            <label htmlFor="RC_sub_1" className="fitem-ck-txt m-0">Twice-Weekly Service</label>
                          </div>
                          <strong className="h6 m-0">76</strong>
                        </div>
                        <div className="d-flex justify-content-between ai-center mb-5">
                          <div className="fitem-check">
                            <input type="checkbox" className="fitem-ck-input" id="RC_sub_2" name="checkboxs"/>
                            <label htmlFor="RC_sub_2" className="fitem-ck-txt m-0">Weekly Service</label>
                          </div>
                          <strong className="h6 m-0">164</strong>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="gray_box yellow_box">
                    <div className="card-body">
                      <div className="fitem-check check-header">
                        <input type="checkbox" className="fitem-ck-input" id="CC_main" name="checkboxs" checked/>
                        <label htmlFor="CC_main" className="fitem-ck-txt">Commercial Cleaning</label>
                      </div>
                      <div className="check-body">
                        <div className="d-flex justify-content-between ai-center mb-5">
                          <div className="fitem-check">
                            <input type="checkbox" className="fitem-ck-input" id="CC_sub_1" name="checkboxs" checked/>
                            <label htmlFor="CC_sub_1" className="fitem-ck-txt m-0">Pet Waste Station Cleaning</label>
                          </div>
                          <strong className="h6 m-0">83</strong>
                        </div>
                        <div className="d-flex justify-content-between ai-center mb-5">
                          <div className="fitem-check">
                            <input type="checkbox" className="fitem-ck-input" id="CC_sub_2" name="checkboxs"/>
                            <label htmlFor="CC_sub_2" className="fitem-ck-txt m-0">Common Area Cleaning</label>
                          </div>
                          <strong className="h6 m-0">23</strong>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="gray_box ltgreen_box">
                    <div className="card-body">
                      <div className="fitem-check check-header">
                        <input type="checkbox" className="fitem-ck-input" id="PWS_main" name="checkboxs" checked/>
                        <label htmlFor="PWS_main" className="fitem-ck-txt">PWS Installations</label>
                      </div>
                      <div className="check-body">
                        <div className="d-flex justify-content-between ai-center mb-5">
                          <div className="fitem-check">
                            <input type="checkbox" className="fitem-ck-input" id="PWS_sub_1" name="checkboxs"/>
                            <label htmlFor="PWS_sub_1" className="fitem-ck-txt m-0">Pet Waste Station Installations</label>
                          </div>
                          <strong className="h6 m-0">2</strong>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mb-20">
                    <Select  showSearch placeholder="State"> <Option>1</Option></Select>
                  </div>
                  <div className="mb-10 side-status-block red-status d-flex justify-content-start ai-center">
                    <span className="number">0</span>
                    <span className="txt">MISSED SERVICES</span>
                  </div>
                  <div className="mb-10 side-status-block grey-status d-flex justify-content-start ai-center">
                    <span className="number">46</span>
                    <span className="txt">AWAITING COMPLETION</span>
                  </div>
                  <div className="mb-10 side-status-block green-status d-flex justify-content-start ai-center">
                    <span className="number">15</span>
                    <span className="txt">COMPLETE</span>
                  </div>
                </div>
                <div className="d-flex justify-content-end w-100 mt-10">
                  <button className="btn btn-brand btn-bdr">Previous</button>
                  <button className="btn btn-primary ml-10">Complete Weekly Setup</button>
                </div>
              </aside>
              <div className="main">
                <h4 className="mb-20">Week Setup: View Allocations</h4>
                <Modal
                  visible={false}
                  className="calendar_pop unassigned_service"
                  width={754}
                  footer={false}
                  centered={true}
                >
                  <h4 className="mb-10">You have 12 unassigned services!</h4>
                  <p>We recognize that 12 services are due to be performed this week, however all your<br></br> technicians are fully allocated. </p>
                  <div className="choose-option">
                    <p className="m-0"><strong>Please choose an option:</strong></p>
                    <div className="choose-option-wrap">
                      <div className="row">
                        <div className="col-4">
                          <p>Rerun Optimization and extend working hours for your techs. </p>
                          <button className="btn btn-primary">Rerun Optimization</button>
                        </div>
                        <div className="col-4">
                          <p>Reschedule all unassigned services notifying each customer.</p>
                          <button className="btn btn-warning">Reschedule Unassigned Services</button>
                        </div>
                        <div className="col-4">
                          <p>Cancel all unassigned services and select a billing preference.</p>
                          <button className="btn btn-danger">Cancel Unassigned Services</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </Modal>

                <Modal
                  visible={false}
                  className="calendar_pop reschedule_service"
                  width={532}
                  centered={true}
                >
                  <h4 className="mb-10">Do you wish to reschedule all services unassigned for this week?</h4>
                  <p>Select your reasoning for rescheduling all unassigned services for this week to notify your customers. All services missed for this week will be rescheduled automatically to one of their preferred days.</p>
                  <div className="mb-20">
                    <label>Reason</label>
                    <Select  showSearch placeholder="State">
                      <Option>Full Allocation</Option>
                    </Select>
                  </div>
                  <div className="mb-10">
                    <textarea className="cust-textarea" rows="5"></textarea>
                  </div>
                  <p className="m-0">*This message will be sent to all customers who are affected by this cancellation. </p>
                </Modal>

                <Modal
                  visible={false}
                  className="calendar_pop"
                  width={532}
                >
                  <h4 className="mb-10">Are you sure you wish to block this day?</h4>
                  <div className="mb-20">
                    <label>Reason</label>
                    <Select  showSearch placeholder="State">
                      <Option>Weather</Option>
                    </Select>
                  </div>
                  <p className="m-0">Once this day has been blocked you will not be able to assign any services to this day. All unassigned services will carry forward to the next available day. </p>
                </Modal>
                <Modal
                  visible={false}
                  className="calendar_pop"
                  width={532}
                >
                  <h4 className="mb-10">Cancel Service</h4>
                  <div className="mb-20">
                    <label>Reason</label>
                    <Select  showSearch placeholder="State">
                      <Option>Weather</Option>
                    </Select>
                  </div>
                  <p>Once this service has been cancelled, the customer will recieve confirmation of their cancellation and their new rescheduled date.</p>
                  <div className="row">
                    <div className="col-6">
                      <div className="fitem-check">
                        <input type="checkbox" className="fitem-ck-input" id="cs-1" name="checkboxs" checked/>
                        <label htmlFor="cs-1" className="fitem-ck-txt">Cancel and bill all customers</label>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="fitem-check">
                        <input type="checkbox" className="fitem-ck-input" id="cs-2" name="checkboxs"/>
                        <label htmlFor="cs-2" className="fitem-ck-txt">{`Cancel and don't bill customers`}</label>
                      </div>
                    </div>
                  </div>
                </Modal>
                <Modal
                  visible={false}
                  className="calendar_pop"
                  width={532}
                >
                  <h4 className="mb-10">Are you sure you wish to move this service?</h4>
                  <p className="m-0">If you move this service, you may be causing conflict with other services. If any service times are changed, the customer will be notified. </p>
                </Modal>
                <Modal
                  visible={false}
                  className="calendar_pop"
                  width={532}
                >
                  <h4 className="mb-10">Do you wish to cancel ALL services  for today?</h4>
                  <p>Deselect any services below that you wish to leave as assigned for today.</p>
                  <div>
                    <div className="service-check-block pt-20 pb-20">
                      <div className="d-flex align-items-center mb-20">
                        <h6 className="m-0">Residential Cleaning</h6>
                        <div className="fitem-check">
                          <input type="checkbox" className="fitem-ck-input" id="rc-all-1" name="checkboxs" checked/>
                          <label htmlFor="rc-all-1" className="fitem-ck-txt">Select All</label>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-6">
                          <div className="fitem-check mb-10">
                            <input type="checkbox" className="fitem-ck-input" id="rc-1" name="checkboxs" checked/>
                            <label htmlFor="rc-1" className="fitem-ck-txt">Gaspar Antunes (11:00-11:30)</label>
                          </div>
                        </div>
                        <div className="col-6">
                          <div className="fitem-check mb-10">
                            <input type="checkbox" className="fitem-ck-input" id="rc-2" name="checkboxs" checked/>
                            <label htmlFor="rc-2" className="fitem-ck-txt">Nguyễn Linh San (11:30-12:00)</label>
                          </div>
                        </div>
                      </div>
                      <a href="/#" className="font-weight-bold text-underline">See More</a>
                    </div>
                    <div className="service-check-block pt-20 pb-20">
                      <div className="d-flex align-items-center mb-20">
                        <h6 className="m-0">Commerical Cleaning</h6>
                        <div className="fitem-check">
                          <input type="checkbox" className="fitem-ck-input" id="cc-all-1" name="checkboxs"/>
                          <label htmlFor="cc-all-1" className="fitem-ck-txt">Select All</label>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-6">
                          <div className="fitem-check mb-10">
                            <input type="checkbox" className="fitem-ck-input" id="cc-1" name="checkboxs" checked/>
                            <label htmlFor="cc-1" className="fitem-ck-txt">Harrison Phillips (9:00-11:00)</label>
                          </div>
                        </div>
                        <div className="col-6">
                          <div className="fitem-check mb-10">
                            <input type="checkbox" className="fitem-ck-input" id="cc-2" name="checkboxs"/>
                            <label htmlFor="cc-2" className="fitem-ck-txt">Yong Tonghyon (14:00-15:30)</label>
                          </div>
                        </div>
                      </div>
                      <a href="/#" className="font-weight-bold text-underline">See More</a>
                    </div>
                    <div className="service-check-block pt-20">
                      <div className="d-flex align-items-center mb-20">
                        <h6 className="m-0">PWS Installations</h6>
                        <div className="fitem-check">
                          <input type="checkbox" className="fitem-ck-input" id="pws-all-1" name="checkboxs"/>
                          <label htmlFor="pws-all-1" className="fitem-ck-txt">Select All</label>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-6">
                          <div className="fitem-check mb-10">
                            <input type="checkbox" className="fitem-ck-input" id="pws-1" name="checkboxs"/>
                            <label htmlFor="pws-1" className="fitem-ck-txt">Lidmila Vilensky (ALL DAY)</label>
                          </div>
                        </div>
                        <div className="col-6">
                          <div className="fitem-check mb-10">
                            <input type="checkbox" className="fitem-ck-input" id="pws-2" name="checkboxs"/>
                            <label htmlFor="pws-2" className="fitem-ck-txt">Lidmila Vilensky (ALL DAY)</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Modal>
                <Modal
                  visible={false}
                  className="calendar_pop"
                  width={532}
                >
                  <h4 className="mb-10">Select and submit your reason for cancelling all services today.</h4>
                  <p>Select your reasoning for cancelling all services today and notify your customers. You will required to submit your EOD Report immediately and reschedule any missed services,.</p>
                  <div className="mb-20">
                    <label>Reason</label>
                    <Select  showSearch placeholder="State">
                      <Option>Weather</Option>
                    </Select>
                  </div>
                  <div className="mb-10">
                    <textarea className="cust-textarea" rows="5"></textarea>
                  </div>
                  <p>*This message will be sent to all customers who are affected by this cancellation. </p>
                  <div className="row">
                    <div className="col-6">
                      <div className="fitem-check">
                        <input type="checkbox" className="fitem-ck-input" id="cb-1" name="checkboxs" checked/>
                        <label htmlFor="cb-1" className="fitem-ck-txt">Cancel and bill all customers</label>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="fitem-check">
                        <input type="checkbox" className="fitem-ck-input" id="cb-2" name="checkboxs"/>
                        <label htmlFor="cb-2" className="fitem-ck-txt">{`Cancel and don't bill customers`}</label>
                      </div>
                    </div>
                  </div>
                </Modal>
                <Modal
                  visible={false}
                  className="calendar_pop"
                  width={532}
                >
                  <h4 className="mb-10">Select Services</h4>
                  <p>Select what action you would like to take with your selected services.</p>
                  <div className="fitem-check cust-radio mb-20">
                    <input type="radio" className="fitem-ck-input" id="radio1" name="select_service"/>
                    <label htmlFor="radio1" className="fitem-ck-txt">Rerun Optimization (for selected services only)</label>
                  </div>
                  <div className="fitem-check cust-radio mb-20">
                    <input type="radio" className="fitem-ck-input" id="radio2" name="select_service" />
                    <label htmlFor="radio2" className="fitem-ck-txt">Reschedule Services</label>
                  </div>
                  <div className="fitem-check cust-radio mb-20">
                    <input type="radio" className="fitem-ck-input" id="radio3" name="select_service" />
                    <label htmlFor="radio3" className="fitem-ck-txt">Cancel Services (select billing preference)</label>
                  </div>
                  <div className="fitem-check cust-radio mb-20">
                    <input type="radio" className="fitem-ck-input" id="radio4" name="select_service" />
                    <label htmlFor="radio4" className="fitem-ck-txt">Mark Services Complete</label>
                  </div>
                </Modal>
                <Modal
                  visible={false}
                  className="calendar_pop"
                  width={753}
                >
                  <h4 className="mb-25">How do you wish to download this route? </h4>
                  <div className="layout-plan d-flex">
                    <div className="layout-plan-left">
                      <p className="fs-13 mb-10"><strong>Select Layout and Format:</strong></p>
                      <div className="d-flex justify-content-between align-items-stretch">
                        <div className="porttrait-block">
                          <div className="porttrait"></div>
                          <div className="fitem-check cust-radio m-0">
                            <input type="radio" className="fitem-ck-input" id="portrait" name="layout" checked/>
                            <label htmlFor="portrait" className="fitem-ck-txt">This is radio btn</label>
                          </div>
                        </div>
                        <div className="landscape-block d-flex flex-column justify-content-between">
                          <div className="landscape"></div>
                          <div className="fitem-check cust-radio m-0">
                            <input type="radio" className="fitem-ck-input" id="landscape" name="layout" />
                            <label htmlFor="landscape" className="fitem-ck-txt">This is radio btn</label>
                          </div>
                        </div>
                      </div>
                      <div>
                        <h6 className="mb-20">Format:</h6>
                        <div className="d-flex align-items-center format-radio justify-content-start">
                          <div className="fitem-check cust-radio m-0">
                            <input type="radio" className="fitem-ck-input" id="pdf" name="format" checked/>
                            <label htmlFor="pdf" className="fitem-ck-txt">.PDF</label>
                          </div>
                          <div className="fitem-check cust-radio m-0">
                            <input type="radio" className="fitem-ck-input" id="html" name="format" />
                            <label htmlFor="html" className="fitem-ck-txt">.HTML</label>
                          </div>
                          <div className="fitem-check cust-radio m-0">
                            <input type="radio" className="fitem-ck-input" id="csv" name="format" />
                            <label htmlFor="csv" className="fitem-ck-txt">.CSV</label>
                          </div>
                        </div>
                      </div>
                      <div className="fitem-check">
                        <input type="checkbox" className="fitem-ck-input" id="email-copy" name="checkboxs" checked/>
                        <label htmlFor="email-copy" className="fitem-ck-txt">Email a copy of this route to the Technician</label>
                      </div>
                    </div>
                    <div className="layout-plan-right">
                      <p className="fs-13 mb-10"><strong>Preview:</strong></p>
                      <div className="preview-pdf"></div>
                    </div>
                  </div>

                </Modal>
              </div>
            </div>
          </div>
        </div>
        <Drawer
          visible={false}
          width={'426'}
          className="drawer-wrapper">
          <div className="group_wrapper rdrawer">
            <div className="card-row">
              <div className="card-full">
                <div className="d-flex justify-content-between mb-20">
                  <div>
                    <h4 className="mb-5">New Franchise Details</h4>
                    <span className="grey fs-13"><strong>Tuesday, July 14th, 8:00 - 10:30</strong></span>
                  </div>
                  <div className="fitem-check">
                    <input type="checkbox" className="fitem-ck-input" id="checkbox3" name="checkboxs" checked/>
                    <label htmlFor="checkbox3" className="fitem-ck-txt">Lock Service</label>
                  </div>
                </div>
                <h5 className="mb-20">701 Valley Dr, Saint Louis, MO 63137</h5>
                <ul className="list-unstyled next-service-list d-flex justify-content-start fs-13">
                  <li className="fs-13">
                    <strong>Next Service</strong>
                    <p className="m-0">Tue, Jul 21</p>
                  </li>
                  <li className="fs-13">
                    <strong>Frequency</strong>
                    <p className="m-0">Weekly</p>
                  </li>
                  <li className="fs-13">
                    <strong>Day</strong>
                    <p className="m-0">Tuesday</p>
                  </li>
                  <li className="fs-13">
                    <strong># of Dogs</strong>
                    <p className="m-0">2</p>
                  </li>
                </ul>
                <div className="subacribe-table fs-13 pt-10 pb-20">
                  <div>
                    <div className="mb-10">
                      <strong>Subscription</strong>
                      <div className="d-flex align-items-center">
                        <p className="m-0">Weekly service, small yard, 2 dogs</p>
                        <strong>$22</strong>
                      </div>
                    </div>
                    <div className="mb-10">
                      <strong>Addon</strong>
                      <div className="d-flex align-items-center">
                        <p className="m-0">Remove waste from property (weekly)</p>
                        <strong>$4</strong>
                      </div>
                    </div>
                  </div>
                  <div className="pt-20 pb-20 subacribe-total">
                    <strong>Addon</strong>
                    <div className="d-flex align-items-center">
                      <p className="m-0">Remove waste from property (weekly)</p>
                      <strong>$24</strong>
                    </div>
                  </div>
                  <button type="button" className="btn btn-warning w-100">View Service Setup</button>
                </div>
                <div className="row gutter-10">
                  <div className="col-12">
                    <div className="mb-10">
                      <label>Assigned Technician (optional)</label>
                      <Select  showSearch>
                        <Option>Carole Chimako</Option>
                      </Select>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="mb-10">
                      <label>Date</label>
                      <TimePicker className="swhite" />
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="mb-20">
                      <label>Start Time (optional)</label>
                      <TimePicker className="swhite" />
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="mb-20">
                      <label>Finish Time (optional)</label>
                      <TimePicker className="swhite" />
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="mb-10">
                      <textarea className="cust-textarea" rows="5"></textarea>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="fitem-check mt-10">
                      <input type="checkbox" className="fitem-ck-input" id="serv-check-1" name="servcheck" checked/>
                      <label htmlFor="serv-check-1" className="fitem-ck-txt">Service Complete </label>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="fitem-check mt-10">
                      <input type="checkbox" className="fitem-ck-input" id="serv-check-2" name="servcheck" />
                      <label htmlFor="serv-check-2" className="fitem-ck-txt">Service Cancelled</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Drawer>
        <Drawer
          visible={false}
          width={'426'}
          className="drawer-wrapper">
          <div className="group_wrapper rdrawer">
            <div className="card-row">
              <div className="card-full">
                <div className="d-flex justify-content-between mb-20">
                  <div className="pr-10">
                    <h4 className="mb-5">Carole Chimako</h4>
                    <span className="grey fs-13"><strong>Sharna has been with DoodyCalls for 2 years and has two fluffy labradoodles</strong></span>
                  </div>
                  <div className="user-photo">
                    <img src="data:image/png;base64,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" alt=""></img>
                  </div>
                </div>
                <div className="user-cont-detail fs-13">
                  <p><strong>Phone:</strong> +1 8217 372 1242</p>
                  <p><strong>Email:</strong> carole.chimako@gmail.com</p>
                  <p><strong>Franchise:</strong> St Louis</p>
                  <p><strong>Group:</strong> Field</p>
                  <p><strong>Roles:</strong> Manager, Field Technician</p>
                </div>
                <div className="mb-20 fs-13">
                  <p className="mb-5"><strong>Start and Stop Location:</strong></p>
                  <p className="mb-5">295 Fulton Street, St Louis 63101</p>
                  <ul className="list-unstyled dash-list">
                    <li className="fs-13">Residential Regular</li>
                    <li className="fs-13">Residential Inital Cleaning</li>
                  </ul>
                </div>
                <div className="pb-20">
                  <p className="mb-5"><strong>Hours of Work (Week 07/14/20):</strong></p>
                  <div className="timing-bloc fs-13 pb-10">
                    <div className="row">
                      <div className="col-6">Monday</div>
                      <div className="col-6">9:30 - 17:00</div>
                    </div>
                    <div className="row">
                      <div className="col-6">Tuesday</div>
                      <div className="col-6">9:30 - 17:00</div>
                    </div>
                    <div className="row">
                      <div className="col-6">Wednesday</div>
                      <div className="col-6">9:30 - 17:00</div>
                    </div>
                    <div className="row">
                      <div className="col-6">Thursday</div>
                      <div className="col-6">9:30 - 17:00</div>
                    </div>
                    <div className="row">
                      <div className="col-6">Friday</div>
                      <div className="col-6">9:30 - 17:00</div>
                    </div>
                  </div>
                  <div className="edit-hours">
                    <div className="row gutter-10 pb-10">
                      <div className="col-4">
                        <div className="fitem-check">
                          <input type="checkbox" className="fitem-ck-input" id="hours-1" name="servcheck" checked/>
                          <label htmlFor="hours-1" className="fitem-ck-txt">Monday</label>
                        </div>
                      </div>
                      <div className="col-4">
                        <TimePicker className="swhite" />
                      </div>
                      <div className="col-4">
                        <TimePicker className="swhite" />
                      </div>
                    </div>
                  </div>
                  <div className="pt-10">
                    <button className="btn btn-warning w-100">Update Working Hours</button>
                  </div>
                  <a href="/#" className="text-underline font-weight-bold">Edit Hours</a>
                </div>

                <div className="mb-10">
                  <label>Status</label>
                  <Select  showSearch>
                    <Option>Active</Option>
                  </Select>
                </div>

                <div className="fitem-check mt-10 mb-20">
                  <input type="checkbox" className="fitem-ck-input" id="cc-check-1" name="servcheck" disabled/>
                  <label htmlFor="cc-check-1" className="fitem-ck-txt">Cancel all services not completed today </label>
                </div>
                <div className="row gutter-10">
                  <div className="col-7">
                    <div className="mb-10">
                      <label>Assign to Technician (optional)</label>
                      <Select  showSearch placeholder="Select Field Tech">
                        <Option>Active</Option>
                      </Select>
                    </div>
                  </div>
                  <div className="col-5">
                    <div className="mb-10">
                      <label>Choose a Day</label>
                      <Select  showSearch placeholder="Select a Day">
                        <Option>Active</Option>
                      </Select>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="mb-10">
                      <label>How soon do you want these service to occur?</label>
                      <Select  showSearch placeholder="Select no. of days">
                        <Option>Active</Option>
                      </Select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Drawer>
      </div>
    );
  }
}

export default WeekSetupViewAllocation;